import React, { useState, useRef } from "react";
import { nanoid } from "nanoid";
import "../App";
import { Link, useHistory } from "react-router-dom";
import "./navigation.css";
import { auth, database, functions, analytics } from "./firebase";
import { FirebaseAuth, useForAuthorisation } from "./context";
import { verifyToken } from "../utils/totp";
import { logAuditToCloud } from "./transactionLoader";
//import HomePage from "./HomePage";

const Login = () => {
  const passwordRef = useRef();
  const emailRef = useRef();
  const { login, signInWithGoogle, location } = useForAuthorisation();

  const [errorMessage, setErrorMessage] = useState();
  const [errorMessageGoogle, seterrorMessageGoogle] = useState();
  const [loadingAccount, setLoadingAccount] = useState(false);
  const historyPage = useHistory();
  const historyPage1 = useHistory();
  const historyPage2 = useHistory();
  const [idNanoid] = React.useState(nanoid);
  const [termsApproved, settermsApproved] = useState(true);
  const [ShowEmailLogin, setShowEmailLogin] = useState();
  var yearDate = new Date();
  // const handleTermsApproved = () => {
  //   settermsApproved(!termsApproved);
  // };

  const [TermsForGoogleSignUp, setTermsForGoogleSignUp] = useState(false);

  // Two-Factor Authentication state
  const [requires2FA, setRequires2FA] = useState(false);
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [twoFactorError, setTwoFactorError] = useState("");
  const [pendingUserUID, setPendingUserUID] = useState(null);
  const [twoFactorSecret, setTwoFactorSecret] = useState("");
  const [twoFactorBackupCodes, setTwoFactorBackupCodes] = useState([]);

  const getReadableLoginErrorMessage = (error, isGoogle = false) => {
    const code = String(error?.code || "").toLowerCase();
    const message = String(
      error?.message || error?.originalMessage || error || "",
    ).toLowerCase();

    const isAppCheckFailure =
      code.startsWith("app-check/") ||
      error?.isAppCheckError ||
      message.includes("app check") ||
      message.includes("appcheck") ||
      message.includes("recaptcha");

    const isTemporaryGoogleServiceFailure =
      (isGoogle &&
        (code === "auth/internal-error" ||
          code === "auth/unavailable" ||
          code === "auth/network-request-failed")) ||
      (isGoogle &&
        (message.includes("internal") || message.includes("unavailable")) &&
        (message.includes("auth") ||
          message.includes("google") ||
          message.includes("popup")));

    if (isAppCheckFailure) {
      return "Security verification expired before Google sign-in could finish. Refresh the page and try again.";
    }

    if (code === "auth/invalid-email") {
      return "The email address format looks invalid. Please check and try again.";
    }

    if (code === "auth/user-disabled") {
      return "This account has been disabled. Please contact support.";
    }

    if (code === "auth/user-not-found") {
      return "No account was found for that email address.";
    }

    if (code === "auth/wrong-password" || code === "auth/invalid-credential") {
      return "Incorrect email or password. Please try again.";
    }

    if (code === "auth/too-many-requests") {
      return "Too many failed attempts. Please wait a few minutes and try again.";
    }

    if (code === "auth/network-request-failed") {
      return "Network error detected. Please check your connection and try again.";
    }

    if (isTemporaryGoogleServiceFailure) {
      return "Google sign-in is temporarily unavailable. Refresh the page and try again, or use email login for now.";
    }

    if (isGoogle && code === "auth/popup-closed-by-user") {
      return "Google sign-in was canceled before completion.";
    }

    if (isGoogle && code === "auth/popup-blocked") {
      return "Your browser blocked the Google sign-in popup. Please allow popups and try again.";
    }

    if (isGoogle && code === "auth/account-exists-with-different-credential") {
      return "An account already exists with this email using a different sign-in method.";
    }

    if (isGoogle && code === "auth/operation-not-allowed") {
      return "Google sign-in is currently unavailable. Please try email login or contact support.";
    }

    if (isGoogle) {
      return "Google sign-in could not be completed. Please try again, or use email login if the issue continues.";
    }

    return "Login was unsuccessful. Please check your details and try again.";
  };

  const handleGoogleTerms = () => {
    setTermsForGoogleSignUp(true);
    setShowEmailLogin(false);
    setErrorMessage("");
    seterrorMessageGoogle("");
  };
  const handleEmailAndPassword = () => {
    setShowEmailLogin(true);
    setTermsForGoogleSignUp(false);
    settermsApproved(true);
    setErrorMessage("");
    seterrorMessageGoogle("");
  };
  // console.log(auth.currentUser.uid);
  // const handleSignInWithGoogle = async (e) => {
  //   e.preventDefault();

  //   await signInWithGoogle()
  //     .then(async (result) => {
  //       setLoadingAccount(true);
  //       database
  //         .ref("/ActiveUser/" + auth.currentUser.uid + "/SignedUp")
  //         .on("value", async (snapshot) => {
  //           //  const accounts =  snapshot.val();
  //           // console.log(accounts);
  //           let signedUp = await snapshot.val();
  //           if (signedUp === true) {
  //             let todayDate = new Date();
  //             // console.log(todayDate);
  //             setLoadingAccount(true);
  //             await database
  //               .ref("/UserSelections/" + auth.currentUser.uid)
  //               .update(
  //                 {
  //                   LastLoggedIn: todayDate,
  //                 },
  //                 (err) => {
  //                   if (err) {
  //                     console.log("error", err);
  //                   } else {
  //                     setLoadingAccount(false);
  //                   }
  //                 }
  //               );
  //             setLoadingAccount(false);
  //             historyPage2.push(location.state || "/AfterLoginPage");
  //             // console.log("============");
  //             // console.log(auth.currentUser.uid);
  //             // console.log(result.user.uid);

  //             return;
  //           }
  //           //   console.log("+++++");
  //           /** @type {firebase.auth.OAuthCredential} */
  //           var credential = result.credential;

  //           // This gives you a Google Access Token. You can use it to access the Google API.
  //           // var token = credential.accessToken;
  //           // The signed-in user info.
  //           // var user = result.user;

  //           let uniqueID = idNanoid;

  //           //added recently - adds user after signup to user/Group with uid
  //           let uid = auth.currentUser.uid;
  //           // functions.useEmulator("localhost", 5001);
  //           var trialPeriod = functions.httpsCallable("trialPeriod");

  //           await trialPeriod({
  //             id: uid,
  //             //can send data as an object
  //           })
  //             .then((result) => {
  //               // Read result of the Cloud Function.
  //               // var sanitizedMessage = result.data.text;
  //               // console.log(result.data);
  //               // console.log("done");
  //               return result;
  //             })
  //             .catch((error) => {
  //               // Getting the Error details.
  //               var code = error.code;
  //               var message = error.message;
  //               var details = error.details;
  //               // ...
  //             });
  //           await database.ref("/PaymentsID/").child(uid).update({
  //             ID: uniqueID,
  //           });
  //           //   console.log(uid);
  //           // using .child(uid) twice to be consistent with other values in signUpAndAddUser component. although we ca have just
  //           // 1 level deep - two levels allow for multiple values to be stored if necessary, etc-but this can be removed.
  //           await database.ref("/User/").child(uid).child(uid).update({
  //             name: result.user.displayName,
  //             email: result.user.email,
  //             //uid below is owner uid - person who added users
  //             userId: uid,
  //             owner: true,
  //             member: false,
  //           });

  //           // await database.ref("/Payments/").child(uid).update({
  //           //   name: googleName,
  //           //   email: result.user.email,
  //           //   //uid below is owner uid - person who added users
  //           //   userId: uid,
  //           //   owner: true,
  //           //   member: false,
  //           //   ID: uniqueID,
  //           // });

  //           await database.ref("/Owner/").child(uid).child(uid).update({
  //             name: result.user.displayName,
  //             // owner/original email
  //             email: result.user.email,
  //             MAINuserId: uid,
  //             //uid below is owner uid - person who added users
  //             userId: uid,
  //             owner: true,
  //             member: false,
  //             address: "no",
  //             telephone: "",
  //             annualOnly: true,
  //           });
  //           // await database.ref("/User/").child(uid).push({
  //           //   clientCompanyAdded: "",
  //           //   afsType: "",
  //           //   Address: "",
  //           //   city: "",
  //           //   province: "",
  //           //   poBox:"",
  //           // });
  //           //
  //           const sameBusinessKey = database
  //             .ref("/User/" + uid + `/ClientCompanyAdded/`)
  //             .push().key;
  //           // console.log(sameBusinessKey);

  //           const companyAddRefdb = database.ref(
  //             "/User/" + uid + "/ClientCompanyAdded/" + sameBusinessKey
  //           );
  //           //posted twice to database- second post is to flatten data structure to enable less bandwith and download, when accessing
  //           // this posted data as an example -when downloading for the cover page. if we have only the first one then we'll have to
  //           // download all the whole tb - current and accounts , we also leave the first post , so company infomation may be ascertained
  //           // while browsing the tb accounts if necessary. it appears to be also used in tb current to have a push key on year roll forward
  //           // to post tb account infomation to.-may remove this-as may not be neccessary-check cover & settings component
  //           const companyAddRefdb1 = database.ref(
  //             "/BusinessDetails/" +
  //               uid +
  //               "/ClientCompanyAdded/" +
  //               sameBusinessKey
  //           );

  //           await companyAddRefdb1.update({
  //             companyNameRef: "Demo Company",
  //             financialsTypeRef: "IFRS SME",
  //             addressRef: "",
  //             cityRef: "City",
  //             provinceRef: "Province",
  //             poBoxRef: "PO BOX",
  //             yearEndDate: yearDate.getFullYear() + 1 + "-02-28",
  //             registrationNumber: yearDate.getFullYear() + 1 + "/0000/000",
  //             sameCompanyKey: sameBusinessKey,
  //             //notes is set to no initially, once user opens notes and clicks open note button, it can update to yes, and
  //             //post notes
  //             notes: "NO",
  //           });

  //           await companyAddRefdb.update({
  //             companyNameRef: "Demo Company",
  //             financialsTypeRef: "IFRS SME",
  //             addressRef: "",
  //             cityRef: "City",
  //             provinceRef: "Province",
  //             poBoxRef: "PO BOX",
  //             yearEndDate: yearDate.getFullYear() + 1 + "-02-28",
  //             registrationNumber: yearDate.getFullYear() + 1 + "/0000/000",

  //             sameCompanyKey: sameBusinessKey,
  //             //notes is set to no initially, once user opens notes and clicks open note button, it can update to yes, and
  //             //post notes
  //             notes: "NO",
  //           });

  //           await database
  //             .ref("/UserAccess/" + uid + "/ClientBusinesses/")
  //             .push({
  //               list: sameBusinessKey,
  //               companyNameRef: "Demo Company",
  //             });
  //           //
  //           analytics.logEvent("sign_up", {
  //             method: "Google",
  //           });
  //           //

  //           //
  //           //console.log("logged");
  //           ///

  //           setLoadingAccount(false);
  //           historyPage1.push(location.state || "/AfterLoginPage");
  //           // ...
  //         });
  //     })
  //     .catch((error) => {
  //       // Handle Errors here.
  //       var errorCode = error.code;
  //       var errorMessage = error.message;
  //       var credential = error.credential;
  //       // The email of the user's account used.
  //       var email = error.email;
  //       // console.log(errorCode, errorMessage, email, credential);
  //       // The firebase.auth.AuthCredential type that was used.
  //       setLoadingAccount(false);
  //       seterrorMessageGoogle("Account Log in unsuccessful");
  //       // ...
  //     });
  //   //setLoadingAccount(false);
  // };

  const handleSignInWithGoogle = async (e) => {
    e.preventDefault();
    setLoadingAccount(true);
    seterrorMessageGoogle("");

    try {
      const result = await signInWithGoogle();
      const uid = auth.currentUser.uid;

      // Check if already signed up
      const signedUpSnapshot = await database
        .ref("/ActiveUser/" + uid + "/SignedUp")
        .once("value");
      const signedUp = signedUpSnapshot.val();

      if (signedUp === true) {
        // Check if 2FA is enabled for this user
        const securitySnapshot = await database
          .ref(`/Owner/${uid}/Security`)
          .once("value");
        const security = securitySnapshot.val();

        if (security && security.twoFactorEnabled) {
          // 2FA is enabled - show verification prompt
          setLoadingAccount(false);
          setRequires2FA(true);
          setPendingUserUID(uid);
          return; // Don't proceed with login until 2FA is verified
        }

        // No 2FA - proceed with normal login
        const todayDate = new Date();
        await database.ref("/UserSelections/" + uid).update({
          LastLoggedIn: todayDate,
        });
        // Fire-and-forget login audit (non-blocking)
        logAuditToCloud(uid, null, "user_login", {
          method: "google",
          timestamp: todayDate.toISOString(),
        }).catch((e) => console.warn("Login audit error (non-blocking):", e));
        setLoadingAccount(false);
        historyPage2.push(location.state || "/AfterLoginPage");
        return;
      }

      // New user setup
      const uniqueID = idNanoid;

      const urlParams = new URLSearchParams(window.location.search);
      const incomingReferralCode = urlParams.get("ref");
      const trialPeriod = functions.httpsCallable("trialPeriod");
      await trialPeriod({
        id: uid,
        nameRef: result.user.displayName,
        emailRef: result.user.email,
        uid: uid,
        uniqueID: uniqueID,
        addressState: "",
        telephoneState: "",
        IndustryState: "",
        countryState: "",
        learned: "",
        tutorialRequest: "",
        incomingReferralCode: incomingReferralCode,
      });
      // await database.ref("/Owner/").child(uid).child(uid).update({
      //   name: result.user.displayName,
      //   email: result.user.email,
      //   MAINuserId: uid,
      //   userId: uid,
      //   owner: true,
      //   member: false,
      //   address: "no",
      //   telephone: "",
      //   annualOnly: true,
      // });

      // const sameBusinessKey = database
      //   .ref("/User/" + uid + `/ClientCompanyAdded/`)
      //   .push().key;

      // const demoCompanyData = {
      //   companyNameRef: "Demo Company",
      //   financialsTypeRef: "IFRS SME",
      //   addressRef: "",
      //   cityRef: "City",
      //   provinceRef: "Province",
      //   poBoxRef: "PO BOX",
      //   yearEndDate: yearDate.getFullYear() + 1 + "-02-28",
      //   registrationNumber: yearDate.getFullYear() + 1 + "/0000/000",
      //   sameCompanyKey: sameBusinessKey,
      //   notes: "NO",
      // };

      // await database
      //   .ref(
      //     "/BusinessDetails/" + uid + "/ClientCompanyAdded/" + sameBusinessKey
      //   )
      //   .update(demoCompanyData);

      // await database
      //   .ref("/User/" + uid + "/ClientCompanyAdded/" + sameBusinessKey)
      //   .update(demoCompanyData);

      // await database.ref("/UserAccess/" + uid + "/ClientBusinesses/").push({
      //   list: sameBusinessKey,
      //   companyNameRef: "Demo Company",
      // });

      analytics.logEvent("sign_up", { method: "Google" });

      setLoadingAccount(false);
      historyPage1.push(location.state || "/AfterLoginPage");
    } catch (error) {
      setLoadingAccount(false);
      seterrorMessageGoogle(getReadableLoginErrorMessage(error, true));
      console.log(error);
    }
  };

  const shouldShowGoogleTroubleshooting =
    !!errorMessageGoogle &&
    (errorMessageGoogle.includes("blocked") ||
      errorMessageGoogle.includes("canceled") ||
      errorMessageGoogle.includes("Refresh the page") ||
      errorMessageGoogle.includes("temporarily unavailable") ||
      errorMessageGoogle.includes("email login"));

  const googleTroubleshootingSteps = errorMessageGoogle?.includes(
    "Refresh the page",
  )
    ? [
        "Refresh this page to renew the security check.",
        "Retry Google sign-in straight after the page reloads.",
        "If the same message returns, use email login while we review the client environment.",
      ]
    : errorMessageGoogle?.includes("temporarily unavailable")
      ? [
          "Retry after a page refresh in case the popup session expired.",
          "Check that browser extensions are not blocking Google or reCAPTCHA requests.",
          "Use email login while Google sign-in is unavailable.",
        ]
      : [
          "Check that browser popups are allowed for this site.",
          "Try disabling browser extensions that block popups or Google scripts.",
          "Make sure you're signed into the correct Google account.",
          "Use email login as an alternative.",
        ];

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      setErrorMessage("");
      setLoadingAccount(true);
      // auth.auth().setPersistence(auth.Persistence.SESSION);
      await login(emailRef.current.value, passwordRef.current.value);

      let MainUserUID = auth.currentUser.uid;

      // Check if 2FA is enabled for this user
      const securitySnapshot = await database
        .ref(`/Owner/${MainUserUID}/Security`)
        .once("value");
      const security = securitySnapshot.val();

      if (security && security.twoFactorEnabled) {
        // 2FA is enabled - show verification prompt
        setLoadingAccount(false);
        setRequires2FA(true);
        setPendingUserUID(MainUserUID);
        setTwoFactorSecret(security.twoFactorSecret || "");
        setTwoFactorBackupCodes(security.twoFactorBackupCodes || []);
        return; // Don't proceed with login until 2FA is verified
      }

      // No 2FA - proceed with normal login
      await completeLogin(MainUserUID);
    } catch (error) {
      setLoadingAccount(false);
      setErrorMessage(getReadableLoginErrorMessage(error));
    }
  };

  const completeLogin = async (MainUserUID) => {
    try {
      setLoadingAccount(true);

      //checks if at least 1 company has been added
      const urlDb = "/UserSelections/" + MainUserUID;
      const newUrlDb = database.ref(urlDb);
      await newUrlDb.once("value", (snapshot) => {
        try {
          setLoadingAccount(true);
          const accounts = snapshot.val();

          let newAccounts = [];

          newAccounts.push({ ...accounts });

          let business =
            newAccounts.map((el1) => Object.keys(el1).length).toString() == 0
              ? "true"
              : "false";

          localStorage.setItem("noSelection", business);
          setLoadingAccount(false);
        } catch (error) {
          setLoadingAccount(false);
          if (error.code && error.code.startsWith("app-check/")) {
            setErrorMessage(
              "App Check verification failed. Please refresh the page and try again.",
            );
          } else {
            console.error("Database read error:", error);
          }
        }
      });

      let todayDate = new Date();
      setLoadingAccount(true);
      await database.ref("/UserSelections/" + MainUserUID).update(
        {
          LastLoggedIn: todayDate,
        },
        (err) => {
          if (err) {
            console.log("error", err);
            if (err.code && err.code.startsWith("app-check/")) {
              setErrorMessage(
                "App Check verification failed. Please refresh the page and try again.",
              );
            }
          } else {
            setLoadingAccount(false);
          }
        },
      );

      // Fire-and-forget login audit (non-blocking)
      logAuditToCloud(MainUserUID, null, "user_login", {
        method: requires2FA ? "email+2fa" : "email",
        timestamp: new Date().toISOString(),
      }).catch((e) => console.warn("Login audit error (non-blocking):", e));

      setLoadingAccount(false);
      historyPage.push(location.state || "/AfterLoginPage");
    } catch (error) {
      setLoadingAccount(false);
      if (error.code && error.code.startsWith("app-check/")) {
        setErrorMessage(
          "App Check verification failed. Please refresh the page and try again.",
        );
      } else {
        setErrorMessage("Error completing login");
      }
    }
  };

  const handleVerify2FACode = async (e) => {
    e.preventDefault();
    setTwoFactorError("");

    if (
      !twoFactorCode ||
      (twoFactorCode.length !== 6 && twoFactorCode.length !== 10)
    ) {
      setTwoFactorError(
        "Please enter a valid 6-digit code or 10-character backup code.",
      );
      return;
    }

    try {
      setLoadingAccount(true);

      // Try client-side verification first (faster UX)
      if (twoFactorCode.length === 6 && twoFactorSecret) {
        const isValid = verifyToken(twoFactorCode, twoFactorSecret);

        if (isValid) {
          // Client-side verification succeeded
          setRequires2FA(false);
          setTwoFactorCode("");
          await completeLogin(pendingUserUID);
          return;
        }
      }

      // Check backup codes client-side
      if (twoFactorCode.length === 10 && twoFactorBackupCodes.length > 0) {
        const backupCodeMatch = twoFactorBackupCodes.find((bc) =>
          typeof bc === "string"
            ? bc === twoFactorCode
            : bc.code === twoFactorCode && !bc.used,
        );

        if (backupCodeMatch) {
          // Backup code is valid - mark as used in database
          const updatedCodes = twoFactorBackupCodes.map((bc) => {
            if (typeof bc === "string") {
              return bc === twoFactorCode
                ? { code: bc, used: true, usedAt: new Date().toISOString() }
                : bc;
            }
            return bc.code === twoFactorCode
              ? { ...bc, used: true, usedAt: new Date().toISOString() }
              : bc;
          });

          await database.ref(`/Owner/${pendingUserUID}/Security`).update({
            twoFactorBackupCodes: updatedCodes,
          });

          const remainingCodes = updatedCodes.filter(
            (bc) => typeof bc === "string" || !bc.used,
          ).length;

          setRequires2FA(false);
          setTwoFactorCode("");
          await completeLogin(pendingUserUID);

          // Show warning about remaining backup codes
          if (remainingCodes === 0) {
            setTimeout(() => {
              alert(
                "⚠️ That was your last backup code! Please generate new backup codes in your profile settings.",
              );
            }, 500);
          } else if (remainingCodes <= 3) {
            setTimeout(() => {
              alert(
                `⚠️ You have ${remainingCodes} backup codes remaining. Consider generating new ones.`,
              );
            }, 500);
          }
          return;
        }
      }
      if (window.location.hostname === "localhost") {
        functions.useEmulator("127.0.0.1", 5001);
      }
      // Fallback to server-side verification
      const verifyTOTP = functions.httpsCallable("verifyTOTP");
      const result = await verifyTOTP({
        code: twoFactorCode,
        uid: pendingUserUID,
      });

      if (result.data.success) {
        // Server verification succeeded
        setRequires2FA(false);
        setTwoFactorCode("");
        await completeLogin(pendingUserUID);

        // Show warning if backup code was used
        if (
          result.data.usedBackupCode &&
          result.data.remainingBackupCodes !== undefined
        ) {
          if (result.data.remainingBackupCodes === 0) {
            alert(
              "⚠️ That was your last backup code! Please generate new backup codes in your profile settings.",
            );
          } else if (result.data.remainingBackupCodes <= 3) {
            alert(
              `⚠️ You have ${result.data.remainingBackupCodes} backup codes remaining. Consider generating new ones.`,
            );
          }
        }
      } else {
        setTwoFactorError("Invalid verification code. Please try again.");
        setLoadingAccount(false);
      }
    } catch (error) {
      console.error("2FA verification error:", error);
      setLoadingAccount(false);

      if (
        error.message.includes("Invalid TOTP code") ||
        error.message.includes("Invalid or already used backup code")
      ) {
        setTwoFactorError(
          "Invalid code. Please check your authenticator app or use a backup code.",
        );
      } else {
        setTwoFactorError("Verification failed. Please try again.");
      }
    }
  };

  const handleCancel2FA = async () => {
    // Sign out the user since they can't proceed without 2FA
    await auth.signOut();
    setRequires2FA(false);
    setTwoFactorCode("");
    setTwoFactorError("");
    setPendingUserUID(null);
  };

  const showPassword = () => {
    if (passwordRef.current.type === "password") {
      passwordRef.current.type = "text";
    } else {
      passwordRef.current.type = "password";
    }
  };

  //
  return (
    <FirebaseAuth>
      <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc" }}>
        {/* Modern Navigation */}
        <nav
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            padding: "1rem 0",
          }}
          className="navbar navbar-expand-lg navbar-dark"
        >
          <div className="container">
            <h1
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                color: "white",
                margin: 0,
                background: "linear-gradient(45deg, #ffffff, #e0e7ff)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              FilingStack
            </h1>

            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/"
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontWeight: "500",
                    }}
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/About"
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontWeight: "500",
                    }}
                  >
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/UsageInfo"
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontWeight: "500",
                    }}
                  >
                    Documentation
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/Pricing"
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontWeight: "500",
                    }}
                  >
                    Pricing
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/ContactPage"
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontWeight: "500",
                    }}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>

              <span>
                <Link
                  style={{
                    color: "white",
                    textDecoration: "none",
                    padding: "8px 20px",
                    borderRadius: "25px",
                    border: "2px solid rgba(255,255,255,0.3)",
                    transition: "all 0.3s ease",
                    fontWeight: "500",
                  }}
                  to="/Signup"
                >
                  Sign up
                </Link>
              </span>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "4rem 0 2rem 0",
            color: "white",
            textAlign: "center",
          }}
        >
          <div className="container">
            <h1
              style={{
                fontSize: "3rem",
                fontWeight: "700",
                marginBottom: "1rem",
                textShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              Welcome Back
            </h1>
            <p
              style={{
                fontSize: "1.2rem",
                opacity: 0.9,
                maxWidth: "600px",
                margin: "0 auto 2rem auto",
                lineHeight: "1.6",
              }}
            >
              Sign in to your FilingStack account and manage your accounting
              with ease
            </p>
          </div>
        </div>

        {/* Login Options */}
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            paddingBottom: "3rem",
          }}
        >
          <div className="container">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
                flexWrap: "wrap",
              }}
            >
              <button
                style={{
                  background: "rgba(255,255,255,0.15)",
                  border: "2px solid rgba(255,255,255,0.3)",
                  color: "white",
                  padding: "12px 30px",
                  borderRadius: "50px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backdropFilter: "blur(10px)",
                  boxShadow: TermsForGoogleSignUp
                    ? "0 0 20px rgba(255,255,255,0.3)"
                    : "none",
                  transform: TermsForGoogleSignUp ? "translateY(-2px)" : "none",
                }}
                className="btn"
                onClick={handleGoogleTerms}
                onMouseOver={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.25)";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = TermsForGoogleSignUp
                    ? "rgba(255,255,255,0.25)"
                    : "rgba(255,255,255,0.15)";
                  e.target.style.transform = TermsForGoogleSignUp
                    ? "translateY(-2px)"
                    : "none";
                }}
              >
                🚀 Login with Google
              </button>
              <button
                style={{
                  background: "rgba(255,255,255,0.15)",
                  border: "2px solid rgba(255,255,255,0.3)",
                  color: "white",
                  padding: "12px 30px",
                  borderRadius: "50px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backdropFilter: "blur(10px)",
                  boxShadow: ShowEmailLogin
                    ? "0 0 20px rgba(255,255,255,0.3)"
                    : "none",
                  transform: ShowEmailLogin ? "translateY(-2px)" : "none",
                }}
                className="btn"
                onClick={handleEmailAndPassword}
                onMouseOver={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.25)";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = ShowEmailLogin
                    ? "rgba(255,255,255,0.25)"
                    : "rgba(255,255,255,0.15)";
                  e.target.style.transform = ShowEmailLogin
                    ? "translateY(-2px)"
                    : "none";
                }}
              >
                ✉️ Login with Email
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div
          style={{
            backgroundColor: "#f8fafc",
            minHeight: "60vh",
            padding: "3rem 0",
          }}
        >
          <div className="container">
            {(TermsForGoogleSignUp || ShowEmailLogin || requires2FA) &&
              !requires2FA && (
                <div
                  style={{
                    textAlign: "center",
                    marginBottom: "2rem",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "2rem",
                      fontWeight: "600",
                      color: "#1e293b",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {TermsForGoogleSignUp
                      ? "🚀 Google Account Login"
                      : ShowEmailLogin
                        ? "✉️ Email & Password Login"
                        : ""}
                  </h2>
                  <p
                    style={{
                      color: "#64748b",
                      fontSize: "1.1rem",
                    }}
                  >
                    {TermsForGoogleSignUp
                      ? "Quick and secure login with your Google account"
                      : "Sign in with your email and password"}
                  </p>
                </div>
              )}

            {/* Two-Factor Authentication Verification */}
            {requires2FA && (
              <div
                style={{
                  maxWidth: "500px",
                  margin: "0 auto",
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                  padding: "3rem",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div style={{ textAlign: "center", marginBottom: "2rem" }}>
                  <div
                    style={{
                      fontSize: "3rem",
                      marginBottom: "1rem",
                    }}
                  >
                    🔐
                  </div>
                  <h2
                    style={{
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      color: "#1e293b",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Two-Factor Authentication
                  </h2>
                  <p
                    style={{
                      color: "#64748b",
                      fontSize: "1rem",
                    }}
                  >
                    Enter the 6-digit code from your authenticator app or use a
                    backup code
                  </p>
                </div>

                <form onSubmit={handleVerify2FACode}>
                  {twoFactorError && (
                    <div
                      style={{
                        marginBottom: "1.5rem",
                        padding: "15px",
                        backgroundColor: "#fef2f2",
                        border: "1px solid #fecaca",
                        borderRadius: "12px",
                        color: "#dc2626",
                        textAlign: "center",
                        fontWeight: "500",
                      }}
                    >
                      ⚠️ {twoFactorError}
                    </div>
                  )}

                  <div style={{ marginBottom: "1.5rem" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                      htmlFor="twoFactorCode"
                    >
                      Verification Code
                    </label>
                    <input
                      type="text"
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        border: "2px solid #e5e7eb",
                        borderRadius: "12px",
                        fontSize: "1.2rem",
                        textAlign: "center",
                        letterSpacing: "0.3em",
                        transition: "all 0.3s ease",
                        outline: "none",
                        backgroundColor: "#f9fafb",
                        fontFamily: "monospace",
                      }}
                      id="twoFactorCode"
                      placeholder="000000"
                      value={twoFactorCode}
                      onChange={(e) =>
                        setTwoFactorCode(
                          e.target.value
                            .replace(/[^0-9A-Za-z]/g, "")
                            .toUpperCase(),
                        )
                      }
                      maxLength={10}
                      autoComplete="off"
                      autoFocus
                      onFocus={(e) => {
                        e.target.style.borderColor = "#3b82f6";
                        e.target.style.backgroundColor = "white";
                        e.target.style.boxShadow =
                          "0 0 0 3px rgba(59, 130, 246, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e5e7eb";
                        e.target.style.backgroundColor = "#f9fafb";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                    <p
                      style={{
                        fontSize: "0.85rem",
                        color: "#6b7280",
                        marginTop: "0.5rem",
                        textAlign: "center",
                      }}
                    >
                      6-digit code from app or 10-character backup code
                    </p>
                  </div>

                  <div style={{ display: "flex", gap: "1rem" }}>
                    <button
                      disabled={loadingAccount}
                      type="submit"
                      style={{
                        flex: 1,
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        border: "none",
                        color: "white",
                        padding: "15px 40px",
                        borderRadius: "50px",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        cursor: loadingAccount ? "not-allowed" : "pointer",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
                        opacity: loadingAccount ? 0.7 : 1,
                      }}
                      onMouseOver={(e) => {
                        if (!loadingAccount) {
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow =
                            "0 6px 25px rgba(102, 126, 234, 0.4)";
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!loadingAccount) {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow =
                            "0 4px 20px rgba(102, 126, 234, 0.3)";
                        }
                      }}
                    >
                      {loadingAccount ? "🔄 Verifying..." : "✓ Verify"}
                    </button>

                    <button
                      type="button"
                      onClick={handleCancel2FA}
                      disabled={loadingAccount}
                      style={{
                        flex: 1,
                        background: "#f1f5f9",
                        border: "2px solid #cbd5e1",
                        color: "#475569",
                        padding: "15px 40px",
                        borderRadius: "50px",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        cursor: loadingAccount ? "not-allowed" : "pointer",
                        transition: "all 0.3s ease",
                        opacity: loadingAccount ? 0.5 : 1,
                      }}
                      onMouseOver={(e) => {
                        if (!loadingAccount) {
                          e.target.style.backgroundColor = "#e2e8f0";
                          e.target.style.transform = "translateY(-2px)";
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!loadingAccount) {
                          e.target.style.backgroundColor = "#f1f5f9";
                          e.target.style.transform = "translateY(0)";
                        }
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Email Login Form */}
            {ShowEmailLogin && !requires2FA && (
              <div
                style={{
                  maxWidth: "500px",
                  margin: "0 auto",
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                  padding: "3rem",
                  border: "1px solid #e2e8f0",
                }}
              >
                <form onSubmit={handleLoginSubmit}>
                  {errorMessage && (
                    <>
                      <div
                        style={{
                          marginBottom: "1.5rem",
                          padding: "15px",
                          backgroundColor: "#fef2f2",
                          border: "1px solid #fecaca",
                          borderRadius: "12px",
                          color: "#dc2626",
                          textAlign: "center",
                          fontWeight: "500",
                        }}
                      >
                        ⚠️ {errorMessage}
                      </div>
                      {(errorMessage.includes("Incorrect") ||
                        errorMessage.includes("No account")) && (
                        <div
                          style={{
                            marginBottom: "1.5rem",
                            padding: "12px 15px",
                            backgroundColor: "#f0f9ff",
                            border: "1px solid #bae6fd",
                            borderRadius: "8px",
                            color: "#0369a1",
                            fontSize: "0.85rem",
                            lineHeight: "1.5",
                          }}
                        >
                          <p style={{ margin: "0 0 8px 0", fontWeight: "600" }}>
                            💡 Try these troubleshooting steps:
                          </p>
                          <ul style={{ margin: "0", paddingLeft: "20px" }}>
                            <li>
                              ✓ Check that you're using the correct email (you
                              may have multiple accounts)
                            </li>
                            <li>✓ Verify CAPS LOCK is off</li>
                            <li>✓ Password is case-sensitive</li>
                            <li>
                              ✓ If forgotten, use the Reset Password link below
                            </li>
                          </ul>
                        </div>
                      )}
                    </>
                  )}

                  <div style={{ marginBottom: "1.5rem" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                      htmlFor="exampleInputEmail1"
                    >
                      Email Address
                    </label>
                    <input
                      type="email"
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        border: "2px solid #e5e7eb",
                        borderRadius: "12px",
                        fontSize: "1rem",
                        transition: "all 0.3s ease",
                        outline: "none",
                        backgroundColor: "#f9fafb",
                      }}
                      id="exampleInputEmail1"
                      placeholder="Enter your email address"
                      ref={emailRef}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#3b82f6";
                        e.target.style.backgroundColor = "white";
                        e.target.style.boxShadow =
                          "0 0 0 3px rgba(59, 130, 246, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e5e7eb";
                        e.target.style.backgroundColor = "#f9fafb";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: "1rem" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "0.5rem",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                      htmlFor="exampleInputPassword1"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        border: "2px solid #e5e7eb",
                        borderRadius: "12px",
                        fontSize: "1rem",
                        transition: "all 0.3s ease",
                        outline: "none",
                        backgroundColor: "#f9fafb",
                      }}
                      id="exampleInputPassword1"
                      placeholder="Enter your password"
                      ref={passwordRef}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#3b82f6";
                        e.target.style.backgroundColor = "white";
                        e.target.style.boxShadow =
                          "0 0 0 3px rgba(59, 130, 246, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e5e7eb";
                        e.target.style.backgroundColor = "#f9fafb";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "2rem",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                    }}
                  >
                    <label
                      htmlFor="showpass"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.9rem",
                        color: "#6b7280",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                    >
                      <input
                        style={{
                          marginRight: "8px",
                          width: "auto",
                          cursor: "pointer",
                        }}
                        id="showpass"
                        type="checkbox"
                        onClick={showPassword}
                      />
                      👁️ Show Password
                    </label>
                    <Link
                      style={{
                        color: "#3b82f6",
                        textDecoration: "none",
                        fontWeight: "500",
                        fontSize: "0.9rem",
                      }}
                      to="/ResetPasscode"
                    >
                      🔐 Reset Password
                    </Link>
                  </div>

                  <button
                    disabled={loadingAccount}
                    type="submit"
                    style={{
                      width: "100%",
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      border: "none",
                      color: "white",
                      padding: "15px 40px",
                      borderRadius: "50px",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      cursor: loadingAccount ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
                      opacity: loadingAccount ? 0.7 : 1,
                    }}
                    className="btn"
                    onMouseOver={(e) => {
                      if (!loadingAccount) {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                          "0 6px 25px rgba(102, 126, 234, 0.4)";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (!loadingAccount) {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                          "0 4px 20px rgba(102, 126, 234, 0.3)";
                      }
                    }}
                  >
                    {loadingAccount ? "🔄 Signing In..." : "🔐 Sign In"}
                  </button>
                </form>
              </div>
            )}

            {/* Google Login Form */}
            {TermsForGoogleSignUp && !requires2FA && (
              <div
                style={{
                  maxWidth: "500px",
                  margin: "0 auto",
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                  padding: "3rem",
                  border: "1px solid #e2e8f0",
                }}
              >
                <form onSubmit={handleSignInWithGoogle}>
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)",
                      borderRadius: "16px",
                      padding: "1.5rem",
                      border: "1px solid #8b5cf6",
                      marginBottom: "2rem",
                    }}
                  >
                    <label
                      htmlFor="showterms"
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        fontSize: "0.95rem",
                        color: "#5b21b6",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                    >
                      <input
                        style={{
                          marginRight: "12px",
                          marginTop: "2px",
                          width: "auto",
                          cursor: "pointer",
                        }}
                        id="showterms"
                        type="checkbox"
                        defaultChecked
                      />
                      <div>
                        <div style={{ fontWeight: "600", marginBottom: "4px" }}>
                          ✅ I agree to the Terms and Conditions
                        </div>
                        <div style={{ fontSize: "0.85rem", opacity: 0.8 }}>
                          By logging in, you agree to our{" "}
                          <Link
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              color: "#6d28d9",
                              textDecoration: "underline",
                              fontWeight: "600",
                            }}
                            to="/TermsAndConditions"
                          >
                            Terms and Conditions and Privacy Policy
                          </Link>
                        </div>
                      </div>
                    </label>
                  </div>

                  <button
                    disabled={loadingAccount}
                    style={{
                      width: "100%",
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      border: "none",
                      color: "white",
                      padding: "15px 40px",
                      borderRadius: "50px",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      cursor: loadingAccount ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
                      opacity: loadingAccount ? 0.7 : 1,
                    }}
                    className="btn"
                    type="submit"
                    onMouseOver={(e) => {
                      if (!loadingAccount) {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                          "0 6px 25px rgba(102, 126, 234, 0.4)";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (!loadingAccount) {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                          "0 4px 20px rgba(102, 126, 234, 0.3)";
                      }
                    }}
                  >
                    {loadingAccount
                      ? "🔄 Signing In..."
                      : "🚀 Sign In with Google"}
                  </button>

                  {errorMessageGoogle && (
                    <>
                      <div
                        style={{
                          marginTop: "1rem",
                          padding: "15px",
                          backgroundColor: "#fef2f2",
                          border: "1px solid #fecaca",
                          borderRadius: "12px",
                          color: "#dc2626",
                          textAlign: "center",
                          fontWeight: "500",
                        }}
                      >
                        ⚠️ {errorMessageGoogle}
                      </div>
                      {shouldShowGoogleTroubleshooting && (
                        <div
                          style={{
                            marginTop: "1rem",
                            padding: "12px 15px",
                            backgroundColor: "#f0f9ff",
                            border: "1px solid #bae6fd",
                            borderRadius: "8px",
                            color: "#0369a1",
                            fontSize: "0.85rem",
                            lineHeight: "1.5",
                          }}
                        >
                          <p style={{ margin: "0 0 8px 0", fontWeight: "600" }}>
                            💡 Troubleshooting Google Sign-In:
                          </p>
                          <ul style={{ margin: "0", paddingLeft: "20px" }}>
                            {googleTroubleshootingSteps.map((step) => (
                              <li key={step}>✓ {step}</li>
                            ))}
                            <li>
                              ✓ Try{" "}
                              <Link
                                to="/Login"
                                onClick={() => setShowEmailLogin(true)}
                                style={{
                                  color: "#0369a1",
                                  fontWeight: "600",
                                  textDecoration: "underline",
                                }}
                              >
                                Email login
                              </Link>{" "}
                              if Google sign-in still fails
                            </li>
                          </ul>
                        </div>
                      )}
                    </>
                  )}
                </form>
              </div>
            )}
          </div>
        </div>

        {/* Loading Indicator */}
        {loadingAccount && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              backdropFilter: "blur(5px)",
            }}
          >
            <div
              style={{
                background: "white",
                padding: "2rem",
                borderRadius: "20px",
                textAlign: "center",
                boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              }}
            >
              <div
                style={{ margin: "0 0 1rem 0" }}
                className="spinner-border text-primary"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
              <p
                style={{
                  margin: 0,
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#1e293b",
                }}
              >
                🔐 Signing you in...
              </p>
              <p
                style={{
                  margin: "0.5rem 0 0 0",
                  fontSize: "0.9rem",
                  color: "#64748b",
                }}
              >
                This will just take a moment
              </p>
            </div>
          </div>
        )}

        {/* Help Section */}
        <div
          style={{
            backgroundColor: "white",
            padding: "3rem 0",
            borderTop: "1px solid #e2e8f0",
          }}
        >
          <div className="container">
            <div
              style={{
                background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
                borderRadius: "20px",
                padding: "2rem",
                textAlign: "center",
                border: "1px solid #bae6fd",
              }}
            >
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  color: "#0c4a6e",
                  marginBottom: "1rem",
                }}
              >
                👋 New to FilingStack?
              </h3>
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#0369a1",
                  marginBottom: "1.5rem",
                }}
              >
                Join accounting professionals who trust FilingStack
              </p>
              <Link
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontWeight: "600",
                  padding: "12px 30px",
                  borderRadius: "25px",
                  background:
                    "linear-gradient(135deg, #0369a1 0%, #0c4a6e 100%)",
                  transition: "all 0.3s ease",
                  display: "inline-block",
                }}
                to="/Signup"
                onMouseOver={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 4px 20px rgba(3, 105, 161, 0.3)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                🚀 Create Free Account
              </Link>
            </div>
          </div>
        </div>
      </div>
    </FirebaseAuth>
  );
};
export default Login;
